import client from './client';

export const referralApi = {
  getMyOverview: () => client.get('/referral/me'),
  getMyChildren: (params?: { page?: number; pageSize?: number }) => client.get('/referral/my-children', { params }),
  getMyRewards: (params?: { page?: number; pageSize?: number }) => client.get('/referral/my-rewards', { params }),
  getMyDailyRewards: (params?: { page?: number; pageSize?: number }) => client.get('/referral/my-daily-rewards', { params }),
};
